// removed by extract-text-webpack-plugin
module.exports = {"footer__two__column_badge":"src-components-footer----footer-module---footer__two__column_badge---2KbeW","footer__two__column__badge__container__box":"src-components-footer----footer-module---footer__two__column__badge__container__box---h10Kn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.module.scss
// module id = 248
// module chunks = 202923723943889